<script setup lang="ts">
import SiteLogo from "./SiteLogo.vue";

const currentYear = new Date().getFullYear();
const operatorName = "广州琴景网络工作室";
</script>

<template>
  <footer class="site-footer">
    <div class="page-width footer-grid">
      <div class="footer-brand">
        <a href="/" data-route aria-label="图萃首页"><SiteLogo /></a>
        <p>检测、分类并下载 1688 商品素材。</p>
        <p class="operator-line">广州琴景网络工作室</p>
      </div>
      <nav aria-label="产品">
        <strong>产品</strong>
        <a href="/" data-route>功能</a>
      </nav>
      <nav aria-label="支持与法律">
        <strong>支持与法律</strong>
        <a href="/privacy/" data-route>隐私政策</a>
        <a href="/terms/" data-route>用户协议</a>
        <a href="/refund-policy/" data-route>退款政策</a>
      </nav>
    </div>
    <div class="page-width footer-bottom">
      <span>© {{ currentYear }} {{ operatorName }}</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备2024241383号-1</a>
    </div>
  </footer>
</template>
